<template>
  <div id="app" :class="[{'openMenuMobile' : openMenuMobile}, currentUser ? currentUser.user.typeRegistration : '']">
    <span class="page-component__scroll"></span>

    <div class="position-relative main-menu-wrap">
      <el-menu
        :default-active="activeIndex"
        class="main-menu"
        mode="horizontal"
        router
        menu-trigger="click"
      >

        <el-row>
          <el-col :span="12" class="logo-wrap">
            <el-menu-item index="0" :route="{name: 'home'}">
              <img style="width: 50px;" :src="!isDashboard() ? logo : logoWhite" alt="">
               <span v-if="currentUser && isDashboard()" :span="8" class="tipe-user-flag">
                  <span v-if="currentUser.user.typeRegistration === 'pj'"><img :src="businessMark" alt=""> EMPRESA</span>
               </span>
            </el-menu-item>
          </el-col>
          <el-col :span="12" class="main-menu-itens">
            <div class="d-flex justify-content-md-end main-menu-itens-wrap">

              <el-menu-item
                 v-if="currentUser"
                 class="d-inline-block d-lg-none"
                 index="7"
                 :route="{name: 'dashboard'}"
                 @click="openMenu">Painel
              </el-menu-item>

              <el-menu-item index="1" :route="{name: 'home'}" @click="openMenu">Início</el-menu-item>

               <el-menu-item index="5" :route="{name: 'search', params: { options: 'new' } }" @click="openMenu">Buscar Bicicleta</el-menu-item>

              <el-menu-item index="2" v-if="!currentUser" :route="{name: 'register'}" @click="openMenu">Anunciar</el-menu-item>

              <el-menu-item index="6" v-show="!isDashboard()" v-if="currentUser" @click="() =>this.$router.push({name: 'my-bikes',  params: { page: 'minhas-bicicletas' } })">Anunciar</el-menu-item>

              <el-menu-item index="3" :route="{name: 'help'}" @click="openMenu">Ajuda</el-menu-item>

              <el-menu-item index="4" :route="{name: 'about'}" @click="openMenu">Sobre a Pedale</el-menu-item>

               <el-menu-item v-if="currentUser" index="2-4" @click="logOut">Sair</el-menu-item>


              <el-menu-item v-if="!currentUser" index="5" @click="() => this.$router.push({name: 'login'}) +  openMenu">Login</el-menu-item>

              <el-submenu
                 v-if="currentUser"
                 index="6"
                 class="sub-menu-main"
              >

                <template slot="title">{{ currentUser ? `Olá ${currentUser.user.firstName}` :  '' }}</template>

                <el-menu-item index="6-5" :route="{name: 'dashboard'}" @click="openMenu">Painel</el-menu-item>

                <el-menu-item index="6-4" @click="() => this.$router.push({name: 'my-bikes',  params: { page: 'minhas-bicicletas' } }) +  openMenu">Painel do Anfitrião</el-menu-item>

                <el-menu-item index="6-3" :route="{name: 'my-reservations'}" @click="openMenu">Painel do Ciclista</el-menu-item>


                <el-menu-item index="6-2" :route="{name: 'chat'}" @click="openMenu">Chat</el-menu-item>

                <el-menu-item index="6-1" :route="{name: 'profile'}" @click="openMenu">Minha Conta</el-menu-item>

                <el-button
                  title="Deslogar-se"
                  type="text"
                  style="padding: 0 10px 10px; color: #909399;"
                  @click="logOut"
                  index="2-4">
                  Sair</el-button>
              </el-submenu>

               <li style="line-height: 50px;" class="d-none d-lg-block">
                  <a :class="isDashboard() ? 'text-white' : ''" style="padding: 20px 5px;" class="font-weight-normal el-menu-item px-2" href="https://pedale.net.br/blog" target="_blank" rel="noopener noreferrer">Blog</a>
               </li>

               <li class="el-menu-item d-none d-lg-block btn-whats-top">
                 <BtnWhatsApp :isDashboard="isDashboard()"></BtnWhatsApp>
               </li>

            </div>
          </el-col>

        </el-row>

      </el-menu>

      <div class="header-mobile">
        <img
          @click="() => this.$router.push({name: 'home'})"
          class="logo-mobile" :src="!isDashboard() ? logo : logoWhite" alt="">
            <span v-if="currentUser && isDashboard()" class="tipe-user-flag">
               <span v-if="currentUser.user.typeRegistration === 'pj'"><img :src="businessMark" alt=""> EMPRESA</span>
            </span>
         <li class="list-unstyled btn-blog-mobile">
            <div class="link-mkt">
               <a :class="isDashboard() ? 'text-white' : 'text-primary'" style="padding-top: 2px; font-size: 1rem;" href="https://pedale.net.br/blog" target="_blank" title="Blog Pedale" class="font-weight-normal el-menu-item d-block d-lg-none px-2" >
                  Blog
               </a>
            </div>
         </li>
         <li class="el-menu-item d-block d-lg-none btn-whats-top" style="position: absolute;  right: 65px; top: -3px">
            <BtnWhatsApp scale="1.6"></BtnWhatsApp>
         </li>
        <el-button class="collapse-menu-icon"  @click="openMenu">
          <v-icon  name="bars"></v-icon>
        </el-button>
      </div>

    </div>
     <div class="main-wrap">
        <transition :name="transitionName" mode="out-in">
         <router-view />
        </transition>
     </div>

     <div v-if="homolog" :class="{'homolog': homolog}" class="environment">Ambiente de Homologação</div>

     <div v-if="development" :class="{'development': development}" class="environment">Ambiente de Desenvolvimento</div>
    <Footer v-if="!is_login()" />

  </div>

</template>

<script>
import Footer from '@/components/Footer.vue';
import BtnWhatsApp from '@/components/BtnWhatsApp.vue';
import {dashboardRouters} from './router/routers-map'
import logo from "./assets/img/logo-pedale.png";
import logoWhite from "./assets/img/logo-pedade-rodape.svg";
import businessMark from  "./assets/img/business-mark.png";


export default {
  name: 'App',
  allowed: false,
  components: {
    Footer,
    BtnWhatsApp
  },
  data() {
    return {
      user: {
          firstName: '',
          lastName: '',
          email: '',
      },
      activeIndex: '1',
      activeIndex2: '1',
      psw: undefined,
      menuOpen: false,
      logo,
      logoWhite,
      openMenuMobile: false,
       homolog: false,
       development: false,
       businessMark
    };
  },
  beforeCreate() {

      /*const checkPsw = () => {
          if (!localStorage.psw || localStorage.psw !== 'tsampaio') {
              setPsw();
          }
          this.$options.allowed = localStorage.psw === 'tsampaio';
      };

      const setPsw = () => {
          this.psw = prompt('Por favor, digite a senha:', undefined);
          localStorage.setItem('psw', this.psw);
      };
*/
      //checkPsw();

  },
  updated() {

  },
  mounted() {

     if (process.env.VUE_APP_MODE === 'development') {
        this.development = true
     }

     if (process.env.VUE_APP_MODE === 'homolog') {
        this.homolog = true
     }
  },
  methods: {

      is_login() {
          let rout = this.$router.currentRoute.name;
          const routersLogin = [
              "login",
              "recover-password",
              "recover-password-token",
              "recover-password-token-id",
              "register"
          ];

          if (routersLogin.indexOf(rout) > -1 ) {
              return true
          }
      },

      /* Checks if it is in the Dashboad |  Verifica se está no painel de controle */
      isDashboard(){

          let routersArr = [];

          for (let i = 0; i < dashboardRouters.length; i++) {
              routersArr.push(dashboardRouters[i].name);
          }

          const rout = this.$router.currentRoute.name;

          const isDashboard = routersArr.includes(rout);

          if (isDashboard) {
              return true
          }
      },

      logOut() {
        this.$loading({
          lock: true,
          text: 'Saindo...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        setTimeout(() => {

          this.$store.dispatch('user/clear')

          if (localStorage.getItem('user')) {
            try {
              localStorage.removeItem('user');
              this.$router.go('/login');
            } catch(e) {
              this.$router.go('/login');
            }
          }

         // loading.close();


        }, 1000);



      },

      //Adiciona uma classe no body, com o nome da rota atual
      addBodyClass() {
          let body = document.querySelector('body');
          let class_name = this.$router.currentRoute.name;
          body.setAttribute("class", (this.isDashboard() ? 'dashboard' : 'site')  + ' ' + class_name);
      },

      openMobileMenu() {

          if (this.$router.currentRoute.name === 'home') {
              this.menuOpen = !this.menuOpen;
          } else {
              this.menuOpen = false;
          }

      },

      goHome() {
          this.$router.push('/');
      },

      openMenu() {
        this.openMenuMobile = !this.openMenuMobile
      }


  },
  computed: {
      currentUser() {
          return this.$store.state.auth.user;
      },
     transitionName() {
        // Verifica se a rota atual é a página inicial ou não
        return this.$route.name === 'home' ? 'none' : 'slide';
     },
  },
  watch: {

    '$route': {
      handler: function(page) {

         this.openMenuMobile = false

        this.addBodyClass();

        if (page.name === 'bike') {
           localStorage.setItem('bike/lastViewed', JSON.stringify(page.params.slug))
        }

        switch (page.name) {
          case 'home':
            this.activeIndex = '1';
            break
          case 'help':
            this.activeIndex = '3';
            break
          case 'about':
            this.activeIndex = '4';
            break
          case 'my-reservations':
            this.activeIndex = '4-1';
            break
          default:
            this.activeIndex = '0';
        }

      },
      deep: true,
      immediate: true
    }

  }

}
</script>

<style lang="scss" scoped>
  //@import './assets/styles/main';

  .dashboard .bg-light {
     @media only screen and (max-width: 996px) {
        min-height: 95vh;
     }
  }

  .environment {
     background: black;
     padding: 7px 20px;
     color: yellow;
     text-align: center;
     font-weight: bold;
     position: fixed;
     bottom: 0;
     left: 0;
     z-index: 1000000;

     &.development {
        background: #6767fd;
        color: #fff;
     }
     &.homolog {
        background: red;
     }
  }


  .dashboard {
     .link-mkt {
        a {
           &:hover, &:focus {
              color: #47b54c !important;
           }
        }
     }
     .header-mobile .btn-whats-top {
        &:hover {
           svg {
              color: #47b54c !important;
           }
        }
     }
  }

  .bike, .advertiser {
     .btn-whats-top {
        display: none !important;
     }

     @media only screen and (min-width: 996px) {
        .main-menu-itens {
           padding-right: 10px;
        }
        }

     @media only screen and (max-width: 996px) {
        .btn-blog-mobile {
           right: 70px;
        }
     }
  }

  .btn-blog-mobile {
     position: absolute;  right: 120px; top: -4px; height: 55px;
  }

</style>
